export class ApiError extends Error {
    constructor (
        public readonly status: number,
        public readonly data: unknown,
    ) {
        super(ApiError.extractMessage(status, data));
        this.name = 'ApiError';
    }

    private static extractMessage (status: number, data: unknown): string {
        const prefix = `API error ${ status }`;

        if (typeof data === 'string' && data.trim()) {
            return `${ prefix }: ${ data }`;
        }

        if (data && typeof data === 'object') {
            const d = data as Record<string, unknown>;
            const candidate =
                      pickString(d.message) ??
                      pickString(d.detail)  ??
                      pickString(d.error)   ??
                      pickString(d.title);

            if (candidate) return `${ prefix }: ${ candidate }`;
        }

        return prefix;
    }
}

function pickString (v: unknown): string | undefined {
    return typeof v === 'string' && v.trim() ? v : undefined;
}
